The URL of a standalone webpage to preview a job ad, with an origin of `job-ad-preview.seek.com`.

The page can be embedded in an iframe or opened in a new tab.

The webpage will expire after 24 hours.
